export function StepsConfig($stateProvider) {
  'ngInject';
  $stateProvider.state('app.steps', {
    url: '',
    abstract: true,
    ignore: true,
    data: {
      permissions: 'signedIn',
    },
    onEnter: (Steps) => Steps.init(),
    onExit: (Steps) => Steps.destroy(),
  });
}
